"use strict";
// State
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESET_USER_DATA = exports.CHANGE_CLIENT = exports.CHANGE_TOKEN_STATE = exports.GENERAL_USER_REDUCER = void 0;
// Types
exports.GENERAL_USER_REDUCER = 'GENERAL_USER_REDUCER';
exports.CHANGE_TOKEN_STATE = 'CHANGE_TOKEN_STATE';
exports.CHANGE_CLIENT = 'CHANGE_CLIENT';
exports.RESET_USER_DATA = 'RESET_USER_DATA';
